module.exports = __webpack_public_path__ + "static/media/activate_instruction.9ac83f38.png";